module.exports = __webpack_public_path__ + "static/media/vegitables_36.b4356289.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_36.csv
// module id = 620
// module chunks = 0